module.exports = __webpack_public_path__ + "officialStatic/img/detail-six-bg.22e4266.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-six-bg.png
// module id = es0w
// module chunks = 0